import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';
import {UtilitiesService} from '../../services/utilities.service';
import {DialogsService} from '../../services/dialog.service';
import {
  ToastSuccessComponent
} from '../../parts/toast-success/toast-success.component';
import {MatSnackBar} from '@angular/material';

@Component({
  selector: 'app-view-quote',
  templateUrl: './view-quote.component.html',
  styleUrls: ['./view-quote.component.css']
})
export class ViewQuoteComponent implements OnInit {
  quoteId: string;
  loadingPolicy: boolean;
  quoteSummary: any;
  showResendQuote = false;
  sendTo: string;
  resendingQuote = false;

  constructor(private route: ActivatedRoute,
              private customerPortalService: RealtorPortalService,
              private dialogService: DialogsService, private router: Router,
              private snakbar: MatSnackBar) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.quoteId = params['id'];

      this.loadingPolicy = true;

      this.customerPortalService.getSideBarInfo().then(sidebar=> {
        this.sendTo = sidebar.Email;
      });
      this.customerPortalService.getPolicySummaryById(this.quoteId)
          .then(ps => {
            this.quoteSummary = ps;
            this.loadingPolicy = false;
          });
    });
  }

  deleteQuote() {
    this.dialogService.confirm('Confirm',
                               'Are you sure you want to delete this quote?')
        .subscribe(result => {
          if (result) {
            this.customerPortalService.deleteQuote(this.quoteId)
                .then(() => {
                  this.snakbar.openFromComponent(ToastSuccessComponent, {
                    data: 'Your quote has been deleted.',
                    duration: 6000,
                    panelClass: ['success-toast']
                  });

                  this.router.navigateByUrl('/home');
                });
          }
        });
  }

  get canResendQuote() {
    return UtilitiesService.isEmailValid(this.sendTo);
  }

  resendQuote() {
    this.resendingQuote = true;

    this.customerPortalService.resendQuote(this.quoteId,this.sendTo).then(()=> {
      this.resendingQuote = false;
      this.showResendQuote = false;
      this.snakbar.openFromComponent(ToastSuccessComponent, {
        data: 'Your quote has re-sent.',
        duration: 6000,
        panelClass: ['success-toast']
      });
    });
  }

  get baseUrl() { return UtilitiesService.baseAPIUrl; }
}
